import Button from "../Button";
import InputText from "../InputText";
import Loader from "../Loader";
import { signIn } from "next-auth/react";
import { useState } from "react";

export default function Login() {
  const [emailAddress, setEmailAddress] = useState("");
  const [status, setStatus] = useState({
    status: "disabled",
    error: "",
  });

  let message;

  switch (status.status) {
    case "success":
      message = "Sent!";
      break;
    case "error":
      message = status.error;
      break;
    case "sending":
      message = <Loader />;
      break;
    default:
      message = "Continue";
  }

  let classes = "mt-4 transition-colors duration-100 px-8";

  if (status.status === "success") {
    classes += " bg-mint color-primary";
  } else if (status.status === "error") {
    classes += " bg-pink color-primary";
  } else if (status.status === "sending") {
    classes += " bg-mint color-primary opacity-50";
  } else if (status.status === "input") {
    classes +=
      " bg-primary color-secondary bg-mint-hover color-primary-hover disabled:opacity-50";
  } else {
    classes += " bg-primary color-secondary disabled:opacity-50";
  }

  return (
    <>
      <form id="login" className="flex flex-col items-start">
        <InputText
          name="email_address"
          type="email"
          value={emailAddress}
          placeholder="Email Address"
          required={true}
          onChange={(ev) => {
            setStatus({
              status: ev.target.validity.valid ? "input" : "disabled",
              error: "",
            });
            setEmailAddress(ev.target.value);
          }}
        />
        <Button
          border={false}
          classes={classes}
          disabled={
            status.status === "disabled" ||
            status.status === "sending" ||
            status.status === "success"
          }
          onClick={async (ev) => {
            ev.preventDefault();
            setStatus({ status: "sending", error: "" });

            signIn("ses", {
              email: emailAddress,
              redirect: false,
            })
              .then(() => setStatus({ status: "success", error: "" }))
              .catch((err) => setStatus({ status: "error", error: err }));
          }}
        >
          {message}
        </Button>
      </form>
    </>
  );
}
